import React, { useCallback } from 'react';
import { PaymentSource } from '../../../constants';
import { reportError } from '../../../lib/reportError';
import { useErrorModal } from '../../../hooks/useErrorModal';
import { useCheckout } from '../../../hooks/useCheckout';
import {
  useCart,
  useUpdateCartMutation,
  CartUpdateAction,
  CartUpdatePropertyName
} from '../../../hooks/useCart';
import { CheckoutSection } from '../../CheckoutSection';
import { useCheckoutFormStates } from '../../CheckoutFormStates';
import { AmazonShippingAndPayment, Mode } from '../AmazonShippingAndPayment';

export const CheckoutAmazonShippingAndPayment: React.FC = () => {
  const { showErrorModal } = useErrorModal();
  const { isShippingAddressSelected, isPaymentMethodSelected } = useCheckout();
  const {
    cart: {
      attributes: { addressId }
    }
  } = useCart();
  const [updateCart] = useUpdateCartMutation();
  const { setFormState } = useCheckoutFormStates();

  const onSwitchToAdyen = useCallback(async () => {
    try {
      await updateCart(CartUpdateAction.PaymentSource, {
        [CartUpdatePropertyName.PaymentSource]: PaymentSource.Adyen
      });
    } catch (error) {
      reportError('CHECKOUT_AMAZON_PAY_SWITCH_TO_ADYEN', error);
      showErrorModal();
    }
  }, [showErrorModal, updateCart]);

  const onModeChange = useCallback(
    (mode: Mode) => {
      setFormState('shippingAddress', mode === Mode.Resting ? 'closed' : 'open');
      setFormState('paymentMethod', mode === Mode.Resting ? 'closed' : 'open');
    },
    [setFormState]
  );

  return (
    <CheckoutSection title="Shipping &amp; Payment">
      <AmazonShippingAndPayment
        addressId={addressId}
        isFilled={isShippingAddressSelected && isPaymentMethodSelected}
        onSwitchToAdyen={onSwitchToAdyen}
        onModeChange={onModeChange}
      />
    </CheckoutSection>
  );
};
